var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("down-time-alerts"),
      _vm.visibleMigrations.length
        ? _c("migrations-alert", {
            attrs: {
              migrations: _vm.visibleMigrations
            }
          })
        : _vm._e(),
      _vm.hasUpgradePromotions ? _c("promotion-banners") : _vm._e(),
      _vm.hasNoCard && !_vm.hasUpgradePromotions
        ? _c("has-no-card-alert")
        : _vm._e(),
      _vm.ticketBanners.length > 0 ? _c("ticket-alerts") : _vm._e(),
      !_vm.loadingData
        ? [
            _vm.accountEmpty
              ? _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "app-card"
                          },
                          [
                            _c("v-card-text", [
                              _c(
                                "h3",
                                {
                                  staticClass: "ma-0 text-md-center"
                                },
                                [_vm._v(" No Hosting Services ")]
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm._e(),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "d-block",
              attrs: {
                cols: "12",
                md: "12"
              }
            },
            [
              _c("services-table", {
                attrs: {
                  title: "Your Hosting Plans",
                  items: _vm.allServicesList,
                  filters: _vm.filters,
                  search: _vm.search,
                  "use-billing-per-page-options": true,
                  "is-simplified": true
                },
                scopedSlots: _vm._u([
                  {
                    key: "header-actions",
                    fn: function fn() {
                      return [
                        _c("g-g-filter", {
                          attrs: {
                            "offset-y": "",
                            left: "",
                            bottom: "",
                            "close-on-content-click": false,
                            items: _vm.filterItems
                          },
                          on: {
                            change: function change($event) {
                              _vm.filters = $event
                            }
                          }
                        }),
                        _c(
                          "div",
                          {
                            staticClass: "w-100",
                            staticStyle: {
                              "max-width": "440px"
                            }
                          },
                          [
                            _c("services-search", {
                              attrs: {
                                compact: ""
                              },
                              model: {
                                value: _vm.search,
                                callback: function callback($$v) {
                                  _vm.search = $$v
                                },
                                expression: "search"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "d-block",
              attrs: {
                cols: "12",
                md: "12"
              }
            },
            [
              _c("services-table", {
                attrs: {
                  title: "Shared With Me",
                  items: _vm.sharedServicesList,
                  filters: _vm.filters,
                  search: _vm.search,
                  "use-billing-per-page-options": true,
                  "is-simplified": true,
                  "hide-icons": ""
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c("tickets-list", {
                attrs: {
                  title: "Open Tickets",
                  compact: "",
                  location: "dashboard",
                  "exclude-statuses": _vm.excludedTicketStatuses,
                  pagination_type: _vm.pagination_type
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [_c("affiliates-top-banner")],
            1
          )
        ],
        1
      ),
      _c("two-fa-enable-modal")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }